'use client';

import { createRoot } from 'react-dom/client';
import { Loading } from 'components/Loading';
import { useEffect } from 'react';
import { browserLogger } from 'utils/logger/browserLogger';
import { getFullErrorObject } from 'utils/getErrorMessage';

const TOPSORT_TOKEN = process.env.NEXT_PUBLIC_TOPSORT_TOKEN || '';

export default function TopsortConfigBody() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.TS?.token) {
        window.TS = {
          ...(window.TS || {}),
          token: TOPSORT_TOKEN,
        };
      }

      if (!window.TS_BANNERS) {
        window.TS_BANNERS = {
          getLink(banner) {
            if (banner.type === 'product') return `https://www.sympla.com.br/evento/${banner.id}`;
            if (banner.type === 'vendor') return `https://www.sympla.com.br/produtor/${banner.id}`;
            if (banner.type === 'url') return banner.id;

            return `https://www.sympla.com.br/evento/${banner.id}`;
          },

          getLoadingElement() {
            const el = document.createElement('div');

            const root = createRoot(el);
            root.render(
              <div>
                <Loading />
              </div>,
            );
            return el;
          },

          getErrorElement(error) {
            const logger = browserLogger();
            logger.init();
            const err = getFullErrorObject<Error>(error);
            logger.error(
              {
                message: 'Topsort error',
                data: err?.message || 'Topsort error',
                extra: { message: err?.message, stack: err?.stack },
              },
              'Topsort',
            );
            const el = document.createElement('div');
            return el;
          },
        };
      }
    }
  }, [TOPSORT_TOKEN]);
  return null;
}
